/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { ProtectedDataSummaryStore } from './protected-data-summary-store';

export const ProtectedDataSummaryStoreContext = createContext<ProtectedDataSummaryStore>({} as ProtectedDataSummaryStore);
